import React, { useContext } from "react";
import PropTypes from "prop-types";
import { HStack, Heading, VStack } from "native-base";
import { FiDollarSign, FiLogOut } from "react-icons/fi";
import { MdOutlineRestore } from "react-icons/md";
import colors from "../../constants/colors";
import { Link as RRDLink, Outlet, useLocation } from "react-router-dom";
import routes from "../../routes";
import { getColorFormat } from "../../utils";
import { StateContext } from "../../contexts";

function Link(props) {
  const { icon: Icon, label, to, ...rest } = props;
  const location = useLocation();

  const active = location.pathname === to;

  return (
    <RRDLink to={to} {...rest}>
      <HStack
        paddingY={3}
        paddingLeft={33}
        space={3}
        backgroundColor={active && getColorFormat(colors.secondary, 0.1)}
        borderRightColor={colors.secondary}
        borderRightWidth={active ? 5 : 0}>
        <Icon size={24} color={active ? colors.secondary : colors.text} />
        <Heading
          fontSize="md"
          color={active ? colors.secondary : colors.text}
          fontWeight={active ? 700 : "normal"}
          numberOfLines={1}>
          {label}
        </Heading>
      </HStack>
    </RRDLink>
  );
}

function ProfileLayout() {
  const state = useContext(StateContext);

  return (
    <VStack minHeight="60vh" paddingTop={5} space={5}>
      <Heading color={colors.secondary} fontSize="xl" paddingX={5}>
        Perfil de usuario
      </Heading>
      <HStack flex={1} alignItems="flex-start">
        <VStack
          backgroundColor={colors.white}
          maxWidth={300}
          height="full"
          width="full">
          <VStack space={1} marginBottom={10}>
            <Link
              icon={FiDollarSign}
              label="Saldo"
              to={routes.profileBalance}
            />
            <Link
              icon={MdOutlineRestore}
              label="Historial de viajes"
              to={routes.home}
              disabled
            />
          </VStack>
          <Link
            icon={FiLogOut}
            label="Cerrar sesión"
            to={routes.home}
            onClick={() => state.updateIsLoggedIn(false)}
          />
        </VStack>
        <VStack flex={1} paddingX={10}>
          <Outlet />
        </VStack>
      </HStack>
    </VStack>
  );
}

Link.propTypes = {
  icon: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};

export default ProfileLayout;
